// ── The workspace brand before anyone has signed in (multi-tenant control plane) ─────────────────
// /api/me carries the brand once signed in (utils/brand.ts); the two sign-in pages are shown before
// that, so they ask GET /api/public/brand. One request per page load, shared by both pages.
import { useEffect, useState } from 'react';
import type { TFunction } from 'i18next';
import { ctrlplaneApi } from './api/ctrlplane';

let pending: Promise<string> | null = null;
const fetchBrand = (): Promise<string> => {
  if (!pending) pending = ctrlplaneApi.publicBrand().then(r => String(r?.brand || '').trim()).catch(() => '');
  return pending;
};

/** The brand ('' = none set or unreachable), or null while the answer is on its way. */
export function usePublicBrand(): string | null {
  const [brand, setBrand] = useState<string | null>(null);
  useEffect(() => { let live = true; fetchBrand().then(b => { if (live) setBrand(b); }); return () => { live = false; }; }, []);
  return brand;
}

/** "<brand> System", else the neutral product name; '' while unknown (no flash of the wrong title). */
export const systemTitle = (t: TFunction, brand: string | null): string =>
  brand === null ? '' : brand ? t('ctrl_system_title', { brand }) : t('ctrl_system_generic');

/** "<brand> Client Portal", else the neutral name; '' while unknown. */
export const clientPortalTitle = (t: TFunction, brand: string | null): string =>
  brand === null ? '' : brand ? t('ctrl_portal_title', { brand }) : t('ctrl_portal_generic');
